import { MEDIA_STATUS, VIDEO_STORAGE, VIDEO_UPLOADS_ID_PREFIX } from '../constants';
import { buildR2VideoUrls } from './buildVideoLinks';

export const computeMediaHasFailed = (data = {}) => !!data.error || data.status === MEDIA_STATUS.FAILED;

export const computeMediaIsPending = (data = {}) => {
  if (computeMediaHasFailed(data)) return false;
  if (typeof data.is_pending === 'boolean') return !!data.is_pending;
  if (data.status) return data.status === MEDIA_STATUS.QUEUED || data.status === MEDIA_STATUS.PROCESSING;
  return false;
};

export const isVideoPosterReady = (videoObject = {}) => (
  !!videoObject.id && !computeMediaIsPending(videoObject) && !computeMediaHasFailed(videoObject)
);

export const shouldShowVideoStatusBadge = (videoObject) => (
  !!videoObject && !!videoObject.id && !isVideoPosterReady(videoObject)
);

export const isImagePosterReady = (imageObject = {}) => (
  !!imageObject.thumbnail && !computeMediaIsPending(imageObject) && !computeMediaHasFailed(imageObject)
);

export const shouldShowImageStatusBadge = (imageObject) => (
  !!imageObject && !!imageObject.thumbnail && !isImagePosterReady(imageObject)
);

export const getReadyImages = (images = []) => images.filter((item) => item.raw || isImagePosterReady(item));

export const resolveMediaStatusBadge = ({ images = [], videos = [] } = {}) => {
  const video = videos[0];
  if (shouldShowVideoStatusBadge(video)) {
    return { type: 'video', item: video };
  }

  const image = images.find(shouldShowImageStatusBadge);
  if (image) {
    return { type: 'image', item: image };
  }

  return null;
};

export const buildImageFields = (data = {}) => ({
  thumbnail: data.thumbnail || data.url,
  full: data.full || data.secure_url || data.url,
  status: data.status,
  error: data.error || data.status === MEDIA_STATUS.FAILED
});

export const buildVideoFields = (data = {}) => {
  const { id, storage } = data;
  const hasExplicitUrls = !!(data.poster_url || data.url || data.secure_url);
  const fallback = (!hasExplicitUrls && storage === VIDEO_STORAGE.R2 && id) ? buildR2VideoUrls(id) : {};

  return {
    thumbnail: data.poster_url || fallback.thumbnail,
    full: data.secure_url || data.url || fallback.full,
    public_id: data.public_id,
    link: data.public_id,
    id,
    storage,
    videoId: data.video_id || id?.replace(VIDEO_UPLOADS_ID_PREFIX, ''),
    status: data.status,
    error: data.error || data.status === MEDIA_STATUS.FAILED
  };
};
